import React, { Component } from "react";
import { connect } from "react-redux";
import { BlueBtn, CustomCheckbox } from "components/Controls";
import {
  loadingSelector,
  activeStepDataSelector,
  appRequestSelector,
} from "containers/MultistepForm/selectors";
import { selectOffer } from "containers/MultistepForm/actions";
import { selectedOfferSelector } from "../../../selectors";

import Form from "./Form";

import "./styles.scss";

class FypnCardForm extends Component {
  state = {
    additionalData: {},
    valid: false,
    smsOptIn: false,
  };

  buildRequestBody = () => {
    const { additionalData, smsOptIn } = this.state;
    const { appRequest, offer } = this.props;

    return {
      ...appRequest,
      ...offer,
      app_id: offer.app_id,
      additional_info_data: {
        ...(offer.additional_info_data || {}),
        creditCard: {
          firstName: additionalData.firstName,
          lastName: additionalData.lastName,
          creditCardNumber: additionalData.creditCardNumber,
          expMonth: additionalData.expMonth,
          expYear: additionalData.expYear,
          securityCode: additionalData.securityCode,
          billingZip: additionalData.billingZip,
        },
        agreementInfo: { isConsentChecked: smsOptIn },
      },
    };
  };

  submitForm = (e) => {
    const { valid } = this.state;
    e.preventDefault();
    if (!valid) return;

    const requestBody = this.buildRequestBody();
    this.props.selectOffer({ selectedOffer: requestBody });
  };

  setAdditionalData = (data) => {
    this.setState({
      additionalData: data.data,
      valid: data.valid,
    });
  };

  toggleSmsOptIn = () => {
    this.setState(({ smsOptIn }) => ({ smsOptIn: !smsOptIn }));
  };

  render() {
    const { loading, activeStepData } = this.props;
    const { valid, smsOptIn } = this.state;

    return (
      <div className="paypair-step-content">
        <div className="fypn-card-form-container">
          <div className="fypn-card-form">
            <div className="fypn-card-form__header">
              <h2 className="fypn-card-form__title">Debit Card Information</h2>
              <p className="fypn-card-form__subtitle">
                We use this to help verify your identity before we creating your
                loan documents.
              </p>
            </div>

            <div className="fypn-card-form__body">
              {activeStepData && activeStepData.error && activeStepData.message && (
                <div className="fypn-card-form__error-message">
                  {activeStepData.message || ""}
                </div>
              )}

              <Form onDataChange={this.setAdditionalData} />
            </div>

            <div className="fypn-card-form__footer">
              <div className="agreemnet-block">
                <div className="flex flex__align--center">
                  <CustomCheckbox
                    value={smsOptIn}
                    onChange={this.toggleSmsOptIn}
                  />
                  <div className="agreemnet-block__label">
                    <span>
                      I agree to receive SMS updates from Fypn about my loan.
                      Message and data rates may apply.
                    </span>
                  </div>
                </div>
              </div>

              <BlueBtn
                customClass="fypn-card-form-submit-btn"
                disabled={!valid}
                loading={loading}
                onClick={this.submitForm}
              >
                Continue
              </BlueBtn>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: loadingSelector()(state),
  offer: activeStepDataSelector()(state),
  activeStepData: activeStepDataSelector()(state),
  selectedOffer: selectedOfferSelector()(state),
  appRequest: appRequestSelector()(state),
});

const mapDistpatchToProps = (dispatch) => {
  return {
    selectOffer: (data) => dispatch(selectOffer(data)),
  };
};

FypnCardForm = connect(mapStateToProps, mapDistpatchToProps)(FypnCardForm);

export default FypnCardForm;
